import { Pencil, Trash2 } from 'lucide-react';
import { formatDate } from '@/lib/dateFormat';
import type { UserAccountId } from '@/services/id-management.service';
import { AccountUsersPopover } from '@/components/id-management/AccountUsersPopover';
import { CategoryIcon } from '@/components/id-management/CategoryIcon';
import { Button } from '@/components/ui/button';

interface Props {
  account: UserAccountId;
  onEdit?: () => void;
  onDelete?: () => void;
}

export function IdAccountCard({ account, onEdit, onDelete }: Props) {
  return (
    <article className="space-y-2 rounded-xl border border-border/60 bg-card p-3">
      <div className="flex items-center gap-2.5">
        <CategoryIcon name={account.category_name} iconPath={account.category_icon_path} className="h-9 w-9 rounded-lg" letterClassName="text-sm" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold leading-tight text-foreground [overflow-wrap:anywhere]">{account.account_identifier}</p>
          <p className="text-xs text-muted-foreground [overflow-wrap:anywhere]">{account.category_name}</p>
        </div>
        {(onEdit || onDelete) && (
          <div className="flex shrink-0 items-center">
            {onEdit && (
              <Button variant="ghost" size="icon" className="h-8 w-8 sm:h-8 sm:w-8" aria-label={`Edit ${account.account_identifier}`} onClick={onEdit}>
                <Pencil className="h-4 w-4" />
              </Button>
            )}
            {onDelete && (
              <Button variant="ghost" size="icon" className="h-8 w-8 sm:h-8 sm:w-8" aria-label={`Delete ${account.account_identifier}`} onClick={onDelete}>
                <Trash2 className="h-4 w-4 text-destructive" />
              </Button>
            )}
          </div>
        )}
      </div>

      <div className="flex items-center justify-between gap-3">
        <AccountUsersPopover users={account.users} accountLabel={account.account_identifier} />
        <p className="shrink-0 text-xs text-muted-foreground">{formatDate(account.updated_at)}</p>
      </div>
    </article>
  );
}
